<template>
  <!--
    作者：zhuchangtao
    时间：2020-12-16
    描述：插件中心-抽奖活动-抽奖设置
  -->
  <div>
    <div class="common-form">复活奖设置</div>
    <el-form-item label="是否开启复活奖" prop="is_revive_lottery">
      <el-switch v-model="form.is_revive_lottery"></el-switch>
      <!-- <p>注：如需使用分销功能必须在 [分销中心 - 分销设置] 中开启</p> -->
    </el-form-item>
   
    <el-form-item label="奖品管理" prop="reviveData" :rules="rulesProduct">
      <el-button icon="el-icon-plus" @click="changeProduct(form.reviveData)">选择奖品</el-button>

      <div class="pt16">
        <el-table size="mini" :data="form.reviveData" :span-method="objectSpanMethod" border style="width: 100%;">
          <el-table-column label="商品名称" width="300">
            <template slot-scope="scope">
              <p class="text-ellipsis-2">{{ scope.row.prize_name }}</p>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input size="small"  type="number" min="1" v-model="scope.row.prize_num"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="优先级">
            <template slot-scope="scope">
              <el-input size="small"  type="number" min="0" v-model="scope.row.sort"></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" :width="type == 'edit' ? 90 : 60">
            <template slot-scope="scope">
              <el-button v-if="type == 'edit'" @click="showFunc(scope.$index, scope.row)" type="text" size="small">{{ scope.row.is_delete == 0 ? '隐藏' : '显示' }}</el-button>
              <el-button @click="deleteClick(scope.$index, true)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <!--商品选择-->
    <Prize :isproduct="isproduct" :excludeIds="excludeIds" :lotterytype="20" :islist="true" @closeDialog="closeDialogFunc"></Prize>


  </div>
</template>

<script>
import PorductApi from '@/api/lottery.js';
import Prize from '@/components/prize/Prize.vue';

import { mergeTable } from '@/utils/table.js';
export default {
  components: {
    /*选择商品组件*/
    Prize

  },
  data() {
    /*验证名称*/
    const validatorProduct = (rule, value, callback) => {
      if(!value){
        return;
      }
      if (value.length < 1) {
        return callback(new Error('请选择商品'));
      } else {

        let flag = false;
        for (let i = 0; i < this.form.reviveData.length; i++) {
          let item = this.form.reviveData[i];

          if (!flag) {
            let reg = item.prize_num == '' || item.sort == '';
            let reg2 =  parseInt(item.prize_num) < 1;
            if (reg || reg2) {
              flag = true;
            }
          }
          if (parseInt(item.prize_num) > 0) {
            item.prizeNumValid = true;
          } else {
            item.prizeNumValid = false;
          }
          if (parseInt(item.sort) > 0) {
            item.sortValid = true;
          } else {
            item.sortValid = false;
          }
          // if (parseInt(item.assemble_stock) > 0) {
          //   item.stockValid = true;
          // } else {
          //   item.stockValid = false;
          // }

          // if (parseInt(item.assemble_price) > 0) {
          //   item.priceValid = true;
          // } else {
          //   item.priceValid = false;
          // }

          // if (parseInt(item.limit_num) > 0) {
          //   item.limit_numValid = true;
          // } else {
          //   item.limit_numValid = false;
          // }

          // if (parseInt(item.sort) > 0) {
          //   item.sortValid = true;
          // } else {
          //   item.sortValid = false;
          // }

          this.$set(this.form.reviveData, i, item);
        }
        if (flag) {
          return callback(new Error('请填写正确的信息'));

        } else {
          callback();
        }
      }
    };

    return {

      /*是否打开选择商品*/
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      /*是否打开规格选择*/
      isspecs: false,
      /*查询规格当前商品*/
      curProduct: {},
      /*当前的角标索引*/
      curIndex: -1,
      /*选择规格*/
      specType: false,
      /*规格去重*/
      SpecExcludeIds: [],
      /*批量拼团价*/
      all_assemble_price: null,
      /*批量拼团库存*/
      all_assemble_stock: null,
      /*批量限购*/
      all_limit_num: null,
      /*开团人数*/
      all_assemble_num: null,
      /*验证商品*/
      rulesProduct: [{ validator: validatorProduct, required: true, trigger: 'blur' }]
    };
  },
  props: {
    form: Object,
    type: String
  },
  created() {},
  methods: {
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      // list.forEach(item => {
      //   arr.push(item.product_id);
      // });
      this.excludeIds = arr;
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            prize_name: item.prize_name,
            lottery_prize_id: item.lottery_prize_id,


            prize_num:0,
            sort:0
          };
          arr.push(obj);
        }
        self.form.reviveData = [];

        self.form.reviveData =self.form.reviveData.concat(arr);
        self.form.reviveData = mergeTable(this.form.reviveData);
      }
    },


    /*删除*/
    deleteClick(e, isType) {
      let curItem=this.form.reviveData[e];

      if (isType) {

        for (let i = 0; i < this.form.reviveData.length; i++) {
          let item = this.form.reviveData[i];
          if (curItem.lottery_prize_id == item.lottery_prize_id) {

            this.form.reviveData.splice(i, 1);
            i--;
          }
        }
      } else {

        let count = 0;
        for (let i = 0; i < this.form.reviveData.length; i++) {
          let item = this.form.reviveData[i];
          if (curItem.lottery_prize_id == item.lottery_prize_id) {
            count++;
            if (count > 1) {
              break;
            }
          }
        }
        if (count > 1) {
          this.form.reviveData.splice(e, 1);
        } else {
          curItem.spec_name = null;
        }
      }

      this.form.reviveData = mergeTable(this.form.reviveData);
    },

    /*表格合并行*/
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if ( columnIndex === 6 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9 || columnIndex === 10) {
        if (row.rowSpan != null) {
          return {
            rowspan: row.rowSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    /*全部应用*/
    allApply() {
      console.log(this.form.reviveData)
      let arr = [];
      for (let i = 0; i < this.form.reviveData.length; i++) {
        let item = this.form.reviveData[i];


        item.prize_num = item.prize_num <= 1 ? this.all_limit_num : item.prize_num;

      }
    },

    /*显示隐藏*/
    showFunc(i, e) {
      if (e.is_delete === 0) {
        e.is_delete = 1;
      } else {
        e.is_delete = 0;
      }
    }
  }
};
</script>

<style lang="scss">
.spec-min-box > i {
  position: absolute;
  right: 0;
  font-size: 16px;
  cursor: pointer;
}
.spec-min-box .el-icon-close {
  top: 0;
  color: red;
  visibility: hidden;
}
td:hover .spec-min-box .el-icon-close {
  visibility: visible;
}
.spec-min-box .el-icon-caret-right {
  bottom: 0;
  transform: rotate(45deg);
  color: #3a8ee6;
}
.el-form-item.is-error .active-all-set .el-input__inner,
.el-form-item.is-error .isvalid .el-input__inner {
  border-color: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/setting/part/Revive.vue